import React from 'react';
import experiments from '../experiments';
import { useExpEnabled } from '../user_hooks';
import AppleSigninButton from './apple_signin_button';
import FacebookSigninButton from './facebook_signin_button';
import GoogleSigninButton from './google_signin_button';
import SigninSeparator from './signin_separator';

interface Props {
  redirectTo?: string;
  isSignup?: boolean;
}

export default function ThirdPartyAuthButtons(props: Props) {
  const googleAuthExpEnabled = useExpEnabled(experiments.GOOGLE_AUTH);

  return (
    <>
      <SigninSeparator />
      <div className="mt-1">
        <FacebookSigninButton
          isSignup={props.isSignup}
          redirectTo={props.redirectTo}
        />
      </div>
      <div className="mt-1">
        <AppleSigninButton
          isSignup={props.isSignup}
          redirectTo={props.redirectTo}
        />
      </div>
      { googleAuthExpEnabled &&
        <div className="mt-1">
          <GoogleSigninButton
            isSignup={props.isSignup}
            redirectTo={props.redirectTo}
          />
        </div>
      }
    </>
  );
}
